import React, {Component} from 'react'
import {withRouter} from "react-router-dom";
import NewClaimMenu from "./newClaimMenu";
import {Button, Grid, Header, Icon} from "semantic-ui-react";
import "./newClaims.css"
import {connect} from "react-redux";
import Footer from "../../footer";
import NewClaimSteps from "./newClaimSteps";
import {getNumberOfUploadsRequired} from "../../../utils/common";
import {ClaimStepsLayout} from "../claimStepsLayout";
import {CustomDivider} from "../../custom-common";
import DocumentExampleCard from "../documentsExamples/documentExampleCard";
import DOCUMENT_EXAMPLES from "../documentsExamples/documentExampleConstant";

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        claimant: state.newClaim.claimant,
        treatmentInfo: state.newClaim.treatmentInfo
    }
};

class UploadInstructions extends Component {
    constructor(props) {
        super(props);
        const { claimant } = this.props;
        if (!claimant) {
            console.warn("No user info")
            this.props.history.replace("/claims");
        }
    }

    onBackHandler = () => {
        this.props.history.replace("/claims/new/treatmentInfo");
    }

    onNext = () => {
        this.props.history.push("/claims/new/uploads")
    }

    render() {
        const button = <Button primary content="Next step" onClick={this.onNext} />;
        const numberOfUploadsRequired = getNumberOfUploadsRequired(this.props.treatmentInfo)
        return (
            <ClaimStepsLayout className={"documents-main-container"} style={{justifyContent: "center"}}>
                <NewClaimMenu onBack={this.onBackHandler} />
                <NewClaimSteps activeStepIdx={1} />
                <div style={{marginTop: "56px"}}>
                <Grid container stackable columns={1} centered>
                    <Grid.Column className={"pageContent uploadInstructions"}>
                        <Header as={"h2"}>Now let's prepare your documents</Header>
                        <p className="neutral700Text">On the next step, you'll be asked to upload <b>at least {numberOfUploadsRequired} </b>
                            supporting documents that help us understand the details of this claim
                        </p>
                        <CustomDivider hidden/>
                        <CustomDivider smaller hidden/>
                        <div className={'colorfulText'}>
                            <b>Here's the type of information we are looking for—</b>
                        </div>
                        <CustomDivider small hidden/>
                        <div className="neutral700Text">
                            <Icon enabled name='check' size='small' color="blue" style={{marginRight: "16px"}}/>Details on the condition and care received
                        </div>
                        <CustomDivider smaller hidden/>
                        <div className="neutral700Text">
                            <Icon enabled name='check' size='small' color="blue" style={{marginRight: "16px"}}/>When and where the condition was diagnosed and/or treated
                        </div>
                        <CustomDivider smaller hidden/>
                        <div className="neutral700Text">
                            <Icon enabled name='check' size='small' color="blue" style={{marginRight: "16px"}}/>The name of the person who was diagnosed
                        </div>
                        <CustomDivider small hidden/>
                        <CustomDivider small hidden/>
                        <div className={'colorfulText'}>
                            <b>This information can typically be found in a number of places, look for documents like—</b>
                        </div>
                        <CustomDivider small hidden/>
                        <p className="neutral700Text small"><Icon enabled name='camera retro' size="large" color="grey" inverted />Photos or scans of documents work just fine</p>
                        <div className={'cardContainer'}>
                            {DOCUMENT_EXAMPLES.map((documentExample, idx) => <DocumentExampleCard key={idx} {...documentExample} />)}
                        </div>
                        <p><Icon enabled name='lightbulb outline' size='small' />
                            <b>Pro tip:</b><i> If your health care provider has a patient login portal, some of these documents can be found there</i>
                        </p>
                    </Grid.Column>
                </Grid>
                </div>
                <div style={{marginTop: "100px"}}>
                    <Footer showTopFooter={true} hasToDisplayCarrierDisclaimer
                        button={button}
                    />
                </div>
            </ClaimStepsLayout>
        )
    }
}

export default connect(mapStateToProps)(withRouter(UploadInstructions));